/**
 * The is essentially an enum representing result from browser compareDocumentPosition API
 * https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
 */
// eslint-disable-next-line etc/no-const-enum
export var DocumentPosition;
(function (DocumentPosition) {
    /**
     * Same node
     */
    DocumentPosition[DocumentPosition["Same"] = 0] = "Same";
    /**
     * Node is disconnected from document
     */
    DocumentPosition[DocumentPosition["Disconnected"] = 1] = "Disconnected";
    /**
     * Node is preceding the comparing node
     */
    DocumentPosition[DocumentPosition["Preceding"] = 2] = "Preceding";
    /**
     * Node is following the comparing node
     */
    DocumentPosition[DocumentPosition["Following"] = 4] = "Following";
    /**
     * Node contains the comparing node
     */
    DocumentPosition[DocumentPosition["Contains"] = 8] = "Contains";
    /**
     * Node is contained by the comparing node
     */
    DocumentPosition[DocumentPosition["ContainedBy"] = 16] = "ContainedBy";
})(DocumentPosition || (DocumentPosition = {}));
//# sourceMappingURL=DocumentPosition.js.map